// extracted by mini-css-extract-plugin
module.exports = {"cartMenuDrawer":"styles_cartMenuDrawer__f9c87","drawerTitle":"styles_drawerTitle__06d10"};